import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Message from '../../../components/message/Message';
import {getOptImage} from 'epic-ue-shared';

export default class LoadIndicator extends Component {
    static propTypes = {
        hide: PropTypes.bool
    };

    render() {
        const {hide} = this.props;

        if (hide) return <div />;
        const img = getOptImage({
            url:
                'https://cdn2.unrealengine.com/Unreal+Engine%2Feg-logo-filled-1255x1272-0eb9d144a0f981d1cbaaa1eb957de7a3207b31bb.png',
            width: 400
        });

        return (
            <div className="load-screen">
                <div className="logo-wrapper">
                    <div className="imgLogo">
                        <img src={img} alt="Epic Games" />
                    </div>
                    <div className="text-wrapper">
                        <h3>
                            <Message code="epic.common.loading" />
                        </h3>
                    </div>
                </div>
            </div>
        );
    }
}
